// src/dataProvider/resources/teams.ts
import { httpClient } from "../../httpClient";
import { buildListQuery, withGlobalClubFilter } from "../clubScope";

const apiUrl = "/api";

type RAListParams = {
  pagination?: { page: number; perPage: number };
  sort?: { field: string; order: "ASC" | "DESC" };
  filter?: any;
};

export function teamsResource(clubId: number | null) {
  const requireClubId = () => {
    if (clubId == null) {
      throw new Error("clubId fehlt (teamsResource). Club muss gesetzt sein.");
    }
    return clubId;
  };

  return {
    // ✅ react-admin getList(params)
    getList: async (params: RAListParams) => {
      const cid = requireClubId();

      const paramsWithClub: any = withGlobalClubFilter(params as any, cid);
      const qs = buildListQuery(paramsWithClub);

      // Backend will clubId als echten Query-Param
      const url = `${apiUrl}/teams?clubId=${encodeURIComponent(String(cid))}&${qs.toString()}`;

      const { json } = await httpClient(url);
      const data = Array.isArray(json) ? json : json?.data ?? [];
      const total =
        typeof json?.total === "number"
          ? json.total
          : Array.isArray(json)
          ? json.length
          : data.length;

      return { data, total };
    },

    // ✅ react-admin getMany({ ids })
    // Wichtig für ReferenceArrayInput: löst ausgewählte IDs wieder in Objekte auf
    getMany: async (params: { ids: any[] }) => {
      const cid = requireClubId();
      const ids = Array.isArray(params?.ids) ? params.ids : [];

      const qs = new URLSearchParams();
      qs.set("clubId", String(cid));
      qs.set("filter", JSON.stringify({ id: ids }));

      const { json } = await httpClient(`${apiUrl}/teams?${qs.toString()}`);
      const data = Array.isArray(json) ? json : json?.data ?? [];
      return { data };
    },
  };
}
